import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext , ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useModal } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import styles from '../envImpairment.module.scss';
import metadata from './RawMaterialsDisposalsComponent.metadata.json5';
import messages from './RawMaterialsDisposalsComponent.messages';
import DisposalSitesComponent from '../subcomponents/DisposalSites/DisposalSitesComponent';
import { useTranslator } from '@jutro/locale';

function RawMaterialsDisposalsComponent(props) {

    // const { submissionVM, pathUpdated, updateWizardData } = props;
    const {
        submissionVM,
        updateWizardData,
        pathUpdated,
        index
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RawMaterialsDisposalsComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const { showConfirm } = useModal();
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();

    modelVM.value.isValidationReq = true

    const addDisposalSites = useCallback(() => {
    
            submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value[index].disposals = 
            submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value[index].disposals || []
    
            const { _xCenter, _dtoName } = _.get(submissionVM, `lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.children[${index}].disposals`)
    
            const disposalVM = viewModelService.create({}, _xCenter, _dtoName);
    
            disposalVM.isValidationReq.value = true
            
            disposalVM.disSitNum.value = submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value[index].disposals.length + 1

            submissionVM.lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value[index].disposals.push(
                disposalVM.value
            );

            const newSubmissionVM = viewModelService.clone(submissionVM);
    
            updateWizardData(newSubmissionVM);
        }, [submissionVM, index, viewModelService, updateWizardData]);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if (changedPath === 'eymaximum1') {
                _.set(modelVM, 'quaPerYea8.value', value)
            }

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [modelVM, pathUpdated, submissionVM, updateWizardData]
    );

    const deleteMaterialsWaste = useCallback(
        () => {
            // eslint-disable-next-line no-secrets/no-secrets
            const infoListPath = 'lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        materialNo: {
            value: index + 1
        },
        RawMaterialsDisposalsAccordionDetails: {
            title: `${translator(messages.rawMaterialsDisposalsInformation)} ${index + 1}`
        },
        RawMaterialsDisposalsAccordion: {
            accordionStates: [`RawMaterialsDisposalsAccordionDetails`]
        },
        disposalSitesComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO.rawMaterialsDisposalsDTO.children[${index}].disposals`,
            index
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteMaterialsWaste,
            addDisposalSites
        },
        resolveComponentMap: {
            disposalSitesComponent: DisposalSitesComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );

}

RawMaterialsDisposalsComponent.propTypes = wizardProps;
export default withRouter(RawMaterialsDisposalsComponent);
